import Icon from '../components/Icon.vue'

Icon.register({
  filter: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M488 0c21.4 0 32 25.9 17 41l-184.9 185v262c0 19.5-22 30.7-37.8 19.7l-80-56c-6.4-4.5-10.2-11.8-10.2-19.7v-206.1l-184.9-185c-15.1-15.1-4.3-41 17-41h463.9z'
      }
    ]
  }
})
